import React, { Component } from 'react';
import { getCurrentLocale } from 'helpers/i18n';
import { languageMapping } from 'helpers/constants';
import { connect } from 'react-redux';
import { updateLanguage } from 'react-localize-redux';

class LanguageOptionsCentered extends Component {
  handleLanguageChange = languageCode => {
    this.props.updateLanguage(languageCode);
    localStorage.setItem('locale', languageCode);
    this.forceUpdate();
    if (this.props.onLanguageChange) {
      this.props.onLanguageChange();
    }
  };

  render() {
    const { defaultLanguages } = this.props;
    if (!defaultLanguages || defaultLanguages.length === 0 || defaultLanguages.length === 1)
      return null;

    const currentLanguage = getCurrentLocale();

    const languages = defaultLanguages.map((language, index) => {
      if (language === currentLanguage) {
        return (
          <span key={`langaugeOption_${language}`}>
            {' '}
            {languageMapping[language]} {index === defaultLanguages.length - 1 ? '' : ' | '}{' '}
          </span>
        );
      } else {
        return (
          <span key={`langaugeOption_${language}`}>
            <button
              type="button"
              className="link-button"
              aria-label={languageMapping[language]}
              onClick={() => this.handleLanguageChange(language)}
            >
              {languageMapping[language]}
            </button>
            {index === defaultLanguages.length - 1 ? '' : ' | '}
          </span>
        );
      }
    });

    return <p className="account-link">{languages}</p>;
  }
}

let LanguageOptionsCenteredConnected = connect(
  store => ({
    defaultLanguages: store.userTypes.defaultLanguages,
  }),
  { updateLanguage }
)(LanguageOptionsCentered);

export default LanguageOptionsCenteredConnected;
